import type { ReactNode } from 'react';
import { useFeature } from '@/stores/features';
import type { FeatureId } from '@/data/featuresRegistry';

type Props = { feature: FeatureId; fallback?: ReactNode; children: ReactNode };

export const FeatureGate = ({ feature, fallback = null, children }: Props) => {
  const on = useFeature(feature);
  return <>{on ? children : fallback}</>;
};
